import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as LgaActions from './lga.actions';
import { LgaService } from '../../services/lga.service';
import { NotificationService } from '@cradua/core';

@Injectable()
export class LgaEffects {
  loadLga$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LgaActions.loadLga),
      exhaustMap((_) =>
        this.lgaService.getallLga().pipe(
          map((data) => LgaActions.loadLgaSuccess({ lga: data })),
          catchError((error) => of(LgaActions.loadLgaFailure({ error })))
        )
      )
    )
  );

  addLga$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LgaActions.addLga),
      concatMap(({ newLga }) =>
        this.lgaService.createlga(newLga).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return LgaActions.addLgaSuccess({ newLga: data });
          }),
          catchError((error) =>
            of(LgaActions.addLgaFailure({ error: error.message }))
          )
        )
      )
    )
  );

  updateLga$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LgaActions.updateLga),
      map((action) => action.updateLga),
      concatMap((updateLga) =>
        this.lgaService.updatelga(updateLga).pipe(
          map(() => {
            this.notification.success('Updated Successfully');
            return LgaActions.updateLgaSuccess({ updateLga: updateLga });
          }),
          catchError((error) =>
            of(LgaActions.updateLgaFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeLga$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LgaActions.removeLga),
      map((action) => action.ids),
      concatMap((ids) =>
        this.lgaService.deleteLga(ids).pipe(
          map(() => {
            this.notification.success('Dated Successfully');
            return LgaActions.removeLgaSuccess({ ids });
          }),
          catchError((error) =>
            of(LgaActions.updateLgaFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private lgaService: LgaService,
    private notification: NotificationService
  ) {}
}
